module.exports = __webpack_public_path__ + "static/media/IMG_4402.94ba9997.jpg";